"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;

/* eslint-disable no-undef */
/**
 *  Copyright (c) 2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

function find(list, predicate) {
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return list[i];
    }
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/graphiql/dist/utility/find.js
 ** module id = 435
 ** module chunks = 0
 **/